import myDriverTypes from './myDriverTypes'

export const getMyDrivers = payload => ({
  type: myDriverTypes.GET_DRVIERS,
  payload
})

export const getMyDriversSuccess = payload => ({
  type: myDriverTypes.GET_DRVIERS_SUCCESS,
  payload
})

export const getMyDriversFailure = payload => ({
  type: myDriverTypes.GET_DRVIERS_FAILURE,
  payload
})

export const clearMyDrivers = () => ({
  type: myDriverTypes.CLEAR_DRVIERS
})

export const setFilters = payload => ({
  type: myDriverTypes.SET_FILTERS,
  payload
})

export const loadMore = payload => ({
  type: myDriverTypes.LOAD_MORE,
  payload
})

export const setMyDriver = (payload, callback) => ({
  type: myDriverTypes.SET_DRVIERS,
  payload,
  callback
})

export const setMyDriverSuccess = payload => ({
  type: myDriverTypes.SET_DRVIERS_SUCCESS,
  payload
})

export const setMyDriverFailure = payload => ({
  type: myDriverTypes.SET_DRVIERS_FAILURE,
  payload
})

export const deleteMyDriver = (payload, callback) => ({
  type: myDriverTypes.DELETE_DRVIERS,
  payload,
  callback
})

export const deleteMyDriverSuccess = payload => ({
  type: myDriverTypes.DELETE_DRVIERS_SUCCESS,
  payload
})

export const deleteMyDriverFailure = payload => ({
  type: myDriverTypes.DELETE_DRVIERS_FAILURE,
  payload
})
